<template>
<div>
    <div v-if="ie=='i'">
        <!-- 玻利维亚(BOL)进口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">进口商ID</th>
                        <td width="25%">{{billInfo.ImporterId}}</td>
                        <th width="25%">净重</th>
                        <td width="25%">{{billInfo.NetWeight}}</td>
                    </tr>
                    <tr>
                        <th>ISIC描述</th>
                        <td>{{billInfo.Isicdesc}}</td>
                        <th>CUODE描述</th>
                        <td>{{billInfo.CuodeDesc}}</td>
                    </tr>
                    <tr>
                        <th>FOB总价（美元）</th>
                        <td>{{billInfo.Value}}</td>
                        <th>FOB单价（美元）</th>
                        <td>{{billInfo.FobUnit}}</td>
                    </tr>
                    <tr>
                        <th>CIF总价（美元）</th>
                        <td>{{billInfo.TotalCif}}</td>
                        <th>CIF单价（美元）</th>
                        <td>{{billInfo.CifUnit}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">运输方式</th>
                        <td width="25%">{{billInfo.TransportType}}</td>
                        <th width="25%">来源国</th>
                        <td width="25%">{{billInfo.Country}}</td>
                    </tr>
                    <tr>
                        <th>起运国</th>
                        <td>{{billInfo.ProvenanceCountry}}</td>
                        <th>目的国</th>
                        <td>{{billInfo.DestinyState}}</td>
                    </tr>
                    <tr>
                        <th>登记号</th>
                        <td>{{billInfo.BillOfLadingNbr}}</td>
                        <th>海关</th>
                        <td>{{billInfo.Custom}}</td>
                    </tr>
                    <tr>
                        <th>进口类型</th>
                        <td>{{billInfo.IMPORT_TYPE}}</td>
                        <th>状态</th>
                        <td>{{billInfo.Status}}</td>
                    </tr>
                    <tr>
                        <th>项目编号</th>
                        <td>{{billInfo.ITEM_NUMBER}}</td>
                        <th>货号对应的税收玻利维亚诺价格</th>
                        <td>{{billInfo.BsTaxUnit}}</td>
                    </tr>
                    <tr>
                        <th>总税(玻利维亚诺)</th>
                        <td>{{billInfo.TotalBsTax}}</td>
                        <th>包装数量</th>
                        <td>{{billInfo.Packages}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
    <div v-if="ie=='e'">
        <!-- 玻利维亚(BOL)出口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">出口商ID</th>
                        <td width="25%">{{billInfo.ExporterId}}</td>
                        <th width="25%">净重</th>
                        <td width="25%">{{billInfo.NetWeight}}</td>
                    </tr>
                    <tr>
                        <th>ISIC描述</th>
                        <td colspan="3">{{billInfo.CiiuDesc}}</td>
                    </tr>
                    <tr>
                        <th>FOB总价（美元）</th>
                        <td>{{billInfo.Value}}</td>
                        <th>CIF总价（美元）</th>
                        <td>{{billInfo.TotalCif}}</td>
                    </tr>
                    <tr>
                        <th>汇率</th>
                        <td colspan="3">{{billInfo.Exchange}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">运输方式</th>
                        <td width="25%">{{billInfo.TransportType}}</td>
                        <th width="25%">来源国</th>
                        <td width="25%">{{billInfo.StateOrigin}}</td>
                    </tr>
                    <tr>
                        <th>目的国</th>
                        <td>{{billInfo.Country}}</td>
                        <th>登记号</th>
                        <td>{{billInfo.Registro}}</td>
                    </tr>
                    <tr>
                        <th>海关</th>
                        <td>{{billInfo.Customs}}</td>
                        <th>包装类型</th>
                        <td>{{billInfo.PackagesType}}</td>
                    </tr>
                    <tr>
                        <th>国际贸易术语</th>
                        <td>{{billInfo.Incoterm}}</td>
                        <th>包装数量</th>
                        <td>{{billInfo.Packages}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
</div>
</template>

<script>
export default {
    props:["billInfo","ie"],
    data() {
        return {

        };
    },
    methods: {
        
    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.partItem {
    margin-bottom: 20px;
    ::v-deep .el-card__header {
        padding: 10px 20px;
        .headTitle {
            display: inline-block;
            padding-left: 10px;
            font-size: 14px;
            border-left: 2px solid var(--themeColor);
            font-weight: bold;
        }
    }
}
table {
    width: 100%;
    border-collapse: collapse;
    tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
        th,
        td {
            font-size: 12px;
            color: #666;
            height: 40px;
            border: 1px solid #eaeaea;
            text-align: center;
        }
        th {
            background-color: #f5f7fa;
            font-weight: 700;
        }
        .bg {
            background-color: var(--themeColor);
            color: #fff;
            font-weight: 700;
            opacity: 0.8;
        }
    }
}
</style>